/* Project Import will be here */
import { getErrorObject, getCashVoucherConfig } from "utilities/utils";
import { getRewardTabsApi, getRewardDashboardApi } from "services/rewards/rewards";
import Constants from "utilities/appConstants";
/* Project Import will be here */

export const types = {
    REWARDS_DASHBOARD_REQUEST: "rewardDashboard/REWARDS_DASHBOARD_REQUEST",
    REWARDS_DASHBOARD_SUCCESS: "rewardDashboard/REWARDS_DASHBOARD_SUCCESS",
    REWARDS_DASHBOARD_FAILURE: "rewardDashboard/REWARDS_DASHBOARD_FAILURE",
    SET_SELECTED_REDEEM_TYPE: "rewardDashboard/SET_SELECTED_REDEEM_TYPE",
    SET_CASH_REWARD_POINTS: "rewardDashboard/SET_CASH_REWARD_POINTS",
    RESET_CASH_POINTS: "rewardDashboard/RESET_CASH_POINTS",

    REWARD_TABS_REQUEST: "rewardDashboard/REWARD_TABS_REQUEST",
    REWARD_TABS_SUCCESS: "rewardDashboard/REWARD_TABS_SUCCESS",
    REWARD_TABS_FAILURE: "rewardDashboard/REWARD_TABS_FAILURE",
};

const initialState = {
    data: {},
    rewardTabs: [],
    isRewardTabsLoading: false,
    rewardTabsError: null,
    selectedRedeemType: Constants.PRODUCT,
    cashPoints: 0,
    selectedPointType: Constants.POINT_TYPE_RBP,
    isLoading: false,
    error: null,
};

export const rewardDashboard = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_SELECTED_REDEEM_TYPE:
            return {
                ...state,
                selectedRedeemType: action.payload,
            };

        case types.SET_CASH_REWARD_POINTS:
            return {
                ...state,
                cashPoints: action.payload,
            };

        /* Keep the previous data while loading, the tab shows the loader over it */
        case types.REWARDS_DASHBOARD_REQUEST:
            return {
                ...state,
                selectedPointType: action.payload.pointType,
                isLoading: true
            };

        case types.REWARDS_DASHBOARD_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };

        case types.REWARDS_DASHBOARD_FAILURE:
            return {
                ...state,
                data: {},
                isLoading: false,
                error: action.payload.error
            };
        case types.RESET_CASH_POINTS:
            return {
                ...initialState
            };

        case types.REWARD_TABS_REQUEST:
            return {
                ...state,
                isRewardTabsLoading: true,
                rewardTabsError: null
            };

        case types.REWARD_TABS_SUCCESS:
            return {
                ...state,
                rewardTabs: action.payload,
                isRewardTabsLoading: false,
                rewardTabsError: null
            };

        case types.REWARD_TABS_FAILURE:
            return {
                ...state,
                rewardTabs: [],
                isRewardTabsLoading: false,
                rewardTabsError: action.payload.error
            };

        default:
            return state;
    }
};

/* Set selected redeem option */
export const setSelectedRedeemType = (type) => {
    return async (dispatch) => {
        dispatch({
            type: types.SET_SELECTED_REDEEM_TYPE,
            payload: type
        });
    }
};

/* Set point to cash converter points */
export const setCashPoints = (points) => {
    return async (dispatch) => {
        dispatch({
            type: types.SET_CASH_REWARD_POINTS,
            payload: points
        });
    }
};

/* Reset the cash points */
export const resetCashPoints = () => {
    return dispatch => {
        dispatch({ type: types.RESET_CASH_POINTS });
    };
};

/* Get reward dashboard details */
export const getRewardDashboard = (pointType) => {
    return async (dispatch, getState) => {
        const selectedPointType =
            pointType || getState().rewardDashboard.selectedPointType;

        dispatch({
            type: types.REWARDS_DASHBOARD_REQUEST,
            payload: { pointType: selectedPointType }
        });

        try {
            const response = await getRewardDashboardApi({
                PointType: selectedPointType
            });

            /* Ignore the response when another tab was selected while this request was in progress */
            if (getState().rewardDashboard.selectedPointType !== selectedPointType)
                return;

            const rewardData = response.data.Data || {};

            dispatch({
                type: types.REWARDS_DASHBOARD_SUCCESS,
                payload: { data: rewardData }
            });

            /* Switch to Product redemption when the selected tab has no cash redemption */
            const { isEnabled: isCashRedemptionEnabled } = getCashVoucherConfig(rewardData);

            if (getState().rewardDashboard.selectedRedeemType === Constants.CASH && !isCashRedemptionEnabled) {
                dispatch({
                    type: types.SET_SELECTED_REDEEM_TYPE,
                    payload: Constants.PRODUCT
                });
            }
        }
        catch (error) {
            if (getState().rewardDashboard.selectedPointType !== selectedPointType)
                return;

            const { message } = getErrorObject(error);

            dispatch({
                type: types.REWARDS_DASHBOARD_FAILURE,
                payload: { error: message }
            });
        }
    };
};

/* Get active reward tabs */
export const getRewardTabs = () => {
    return async (dispatch) => {
        dispatch({ type: types.REWARD_TABS_REQUEST });

        try {
            const response = await getRewardTabsApi();

            dispatch({
                type: types.REWARD_TABS_SUCCESS,
                payload: response.data.Data || []
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);

            dispatch({
                type: types.REWARD_TABS_FAILURE,
                payload: { error: message }
            });
        }
    };
};